/**
 * AIMixingToggle Component
 * Toggle for AI Mixing Assistant panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Brain } from 'lucide-react';

export const AIMixingToggle = ({
  showAIMixing,
  setShowAIMixing,
  isSimplifiedMode = false,
}) => {
  if (isSimplifiedMode) return null;
  
  return (
    <Button
      variant={showAIMixing ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setShowAIMixing(!showAIMixing)}
      className={`relative p-2 ${showAIMixing ? 'bg-purple-500/20 text-purple-400 border border-purple-500/50' : 'text-zinc-400 hover:text-white hover:bg-purple-500/20'}`}
      data-testid="ai-mixing-btn"
      title="AI Mixing Assistant"
    >
      <Brain className="w-5 h-5" />
    </Button>
  );
};

export default AIMixingToggle;
